export default __webpack_public_path__ + "static/media/EAST0888.34I-35137_-20229_0.696665e3.jpg";